/** @internal */
export const OP_CONTINUATION_K = "ContinuationK";
/** @internal */
export const OP_CONTINUATION_FINALIZER = "ContinuationFinalizer";
//# sourceMappingURL=continuation.js.map